import React from "react";

const AdminContact = ({ adminContact }) => {
  return adminContact ? (
    <React.Fragment>
      <h5>Contacts</h5>
      <ul className="list-style-none">
        <li>
          <h6>Type: </h6>
          <span> Administrative Contact</span>
        </li>
        <li>
          <h6>Name: </h6>
          <span className="text-uppercase">
            {" "}
            {adminContact.firstName} {adminContact.lastName}
          </span>
        </li>
        <li>
          <h6>Office: </h6>
          <span> {adminContact.phone}</span>
        </li>
        <li>
          <h6>Emergency: </h6>
          <span> {adminContact.phone2}</span>
        </li>
        <li>
          <h6>Email: </h6>
          <span> {adminContact.email}</span>
        </li>
      </ul>
    </React.Fragment>
  ) : (
    <React.Fragment>
      <h5>Contacts</h5>
      <ul className="list-style-none">
        <li>
          <h6>Type: </h6>
          <span> Administrative Contact</span>
        </li>
        <li>
          <h6>Name: </h6>
        </li>
        <li>
          <h6>Office: </h6>
        </li>
        <li>
          <h6>Emergency: </h6>
        </li>
        <li>
          <h6>Email: </h6>
        </li>
      </ul>
    </React.Fragment>
  );
};

export default AdminContact;
